import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

export const Login = () => {
  const { login, loading, error, setError } = useAuth();
  const navigate = useNavigate();
  const [form, setForm] = useState({ identifier: '', password: '' });
  const [showPw, setShowPw] = useState(false);

  const setField = (k, v) => { setForm(p => ({ ...p, [k]: v })); setError(''); };

  const handleSubmit = async (e) => {
    e?.preventDefault();
    if (!form.identifier || !form.password) { setError('Veuillez remplir tous les champs.'); return; }
    const result = await login(form.identifier, form.password);
    if (result?.success) {
      if (result.passwordResetRequired) {
        navigate('/change-password', { replace: true });
      } else {
        navigate('/', { replace: true });
      }
    }
  };

  return (
    <div className="auth-screen">
      <div className="auth-card">
        {/* LOGO */}
        <div className="auth-logo">
          <div className="auth-logo-text">
            <span className="logo-accent">LAV</span>EX
          </div>
        </div>
        <div className="auth-tagline">
          Plateforme d'administration &nbsp;·&nbsp;
          <span className="auth-admin-pill">🔐 ADMIN</span>
        </div>

        {/* SECURITY NOTICE */}
        <div className="inline-alert inline-alert-blue" style={{ marginBottom: 24 }}>
          <span style={{ fontSize: 16 }}>🛡️</span>
          <div>
            <strong>Accès restreint.</strong> Cette interface est réservée aux administrateurs LAVEX.
            Toute tentative d'accès non autorisée est enregistrée.
          </div>
        </div>

        {/* ERROR */}
        {error && (
          <div className="inline-alert inline-alert-red" style={{ marginBottom: 16 }}>
            <span>⚠️</span>
            <span>{error}</span>
          </div>
        )}

        {/* FORM */}
        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label className="form-label">Email ou Téléphone</label>
            <input
              className="form-input"
              type="text"
              placeholder="admin@lavex.ma"
              value={form.identifier}
              onChange={e => setField('identifier', e.target.value)}
              autoComplete="username"
            />
          </div>

          <div className="form-group">
            <label className="form-label">Mot de passe</label>
            <div style={{ position: 'relative' }}>
              <input
                className="form-input"
                type={showPw ? 'text' : 'password'}
                placeholder="••••••••"
                value={form.password}
                onChange={e => setField('password', e.target.value)}
                autoComplete="current-password"
                style={{ paddingRight: 40 }}
              />
              <button
                type="button"
                onClick={() => setShowPw(p => !p)}
                style={{ position: 'absolute', right: 12, top: '50%', transform: 'translateY(-50%)', background: 'none', border: 'none', color: 'var(--text3)', cursor: 'pointer', fontSize: 14 }}
              >
                {showPw ? '🙈' : '👁️'}
              </button>
            </div>
          </div>

          <button
            type="submit"
            className="btn btn-primary btn-full btn-lg"
            style={{ marginTop: 8 }}
            disabled={loading}
          >
            {loading
              ? <><span className="spinner" style={{ width: 16, height: 16 }} /> Connexion en cours...</>
              : 'Se connecter'}
          </button>
        </form>

        <p style={{ textAlign: 'center', fontSize: 11, color: 'var(--text3)', marginTop: 24 }}>
        </p>
      </div>
    </div>
  );
};
